export default {
  apiKey: "AIzaSyBvwyxnen3FJ0OPEbHh3a9yglANWf1uzgQ",
  authDomain: "ice-cream-for-two.firebaseapp.com",
  databaseURL: "https://ice-cream-for-two.firebaseio.com",
  projectId: "ice-cream-for-two",
  storageBucket: "ice-cream-for-two.appspot.com",
  messagingSenderId: "817223005884",
  appId: "1:817223005884:web:bc06902736c3de116782b9"
};